export default __webpack_public_path__ + "static/media/minio3.371a7dcc.jpg";